
import { defaultStyles, TooltipWithBounds } from '@visx/tooltip';
import { useTheme } from '@material-ui/core/styles';
import { CHART_THEME } from './chartTheme';

interface TooltipData {
  title: string;
  items: { color: string; label: string; value: string }[];
}

interface Props {
  top: number;
  left: number;
  data: TooltipData;
}

export const ChartTooltip = ({ top, left, data }: Props) => {
  const muiTheme = useTheme();
  const mode = muiTheme.palette.type === 'dark' ? 'dark' : 'light';
  const colors = CHART_THEME[mode];

  return (
    <TooltipWithBounds
      top={top}
      left={left}
      style={{
        ...defaultStyles,
        backgroundColor: colors.tooltipBg,
        border: `1px solid ${colors.tooltipBorder}`,
        color: colors.tooltipText,
        padding: '8px 12px',
        fontSize: 12,
        lineHeight: 1.5,
        borderRadius: 4,
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{data.title}</div>
      {data.items.map((item, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: item.color,
              display: 'inline-block',
              flexShrink: 0,
            }}
          />
          <span style={{ opacity: 0.7 }}>{item.label}:</span>
          <span style={{ fontWeight: 500 }}>{item.value}</span>
        </div>
      ))}
    </TooltipWithBounds>
  );
};
